<template>
  <div>
    <diffInput
      :optList="filterType"
      v-model="select"
      type="select"
      title="Boşa Çıkma Tarihi"
    />

    <div class="w-full px-2" v-if="select == 4">
      <div class="my-4">
        <diffInput
          :min="minDate"
          :max="endDate"
          v-model="startDate"
          type="date"
          title="Başlangıç"
          required
        />
      </div>
      <diffInput
        :max="maxDate"
        required
        :min="startDate"
        v-model="endDate"
        type="date"
        title="Bitiş"
      />
    </div>
  </div>
</template>

<script>
//npm
import moment from "moment";

//Global Components
import diffInput from "@/components/general/diffInput.vue";

export default {
  name: "delivery-input",
  props: ["value", "detail"],
  model: {
    event: "change",
    prop: "value",
  },
  components: {
    diffInput,
  },
  data() {
    return {
      select: 1,
      startDate: null,
      endDate: null,
      filterType: [
        {
          id: 1,
          name: "Tümü",
        },
        {
          id: 2,
          name: "Bu Gün",
        },
        {
          id: 3,
          name: "Yarın",
        },
        {
          id: 4,
          name: "Özel Tarih",
        },
      ],
    };
  },
  created() {
    this.select = this.value;
    this.startDate = this.detail.start;
    this.endDate = this.detail.end;
  },
  computed: {
    maxDate() {
      return moment().add("years", 2).format("YYYY-MM-DD");
    },
    minDate() {
      return moment().add("years", -10).format("YYYY-MM-DD");
    },
  },
  watch: {
    detail(val) {
      this.startDate = val.start;
      this.endDate = val.end;
    },
    startDate(val) {
      this.$emit("changeStartDate", val);
    },
    endDate(val) {
      this.$emit("changeEndDate", val);
    },
    value(val) {
      if (val) this.select = val;
    },
    select(val) {
      if (val) {
        if (val < 4)
          this.$emit(
            "changeEndDate",
            val == 2
              ? moment().format("YYYY-MM-DD")
              : val == 3
              ? moment().add("1", "days").format("YYYY-MM-DD")
              : null
          );
        this.$emit("change", val);
      }
    },
  },
};
</script>
